import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "loading", "refetch"];
import { registerQuery, useQuery } from 'data-fetching-client';
import { useRefetchOnWindowFocus } from '../utils/useRefetchOnWindowFocus';
import { api } from '../utils/api';
import { FORM_DATA_PATH, PREVIEW_FORM_DATA_PATH } from '../../api/paths';
import { getIsPreview } from '../utils/isPreview';
const GET_FORM_DATA_KEY = 'getFormData';
const getFormData = async () => {
  const {
    isPreview
  } = getIsPreview();
  const path = isPreview ? PREVIEW_FORM_DATA_PATH : FORM_DATA_PATH;
  const response = await api(path);
  return response.json();
};
const GET_FORM_DATA = registerQuery({
  fieldName: GET_FORM_DATA_KEY,
  fetcher: getFormData
});
export const useFormData = () => {
  const _useQuery = useQuery(GET_FORM_DATA),
    {
      data,
      loading,
      refetch
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  useRefetchOnWindowFocus({
    refetch,
    loading
  });
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data[GET_FORM_DATA_KEY],
    refetch,
    loading
  }, rest);
};